<template>
    <div class="content">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询条件</span>
            </div>
            <div class="box-cont">
                <el-form :model="queryParams" ref="queryForm" :inline="true">
                    <el-form-item label="用户身份:" prop="yhsf">
                        <el-input
                        v-model="queryParams.yhsf"
                        placeholder="请输入"
                        clearable
                        size="small"
                        @keyup.enter.native="handleQuery"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="handleQuery">查询</el-button>
                        <el-button icon="el-icon-refresh" size="small" @click="resetQuery">重置</el-button>
                        <!--<el-button type="danger" v-if="xz=='1'" icon="el-icon-plus" size="small" @click="handleAdd">新增</el-button>-->
                    </el-form-item>
                </el-form>
            </div>
        </el-card>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="text">查询结果</span>
            </div>
            <div class="box-cont">
                <el-table v-loading="loading" :data="ajslList">
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="80">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="用户身份" align="center" prop="yhsf" />
                    <el-table-column label="查看权限" align="center" class-name="small-padding fixed-width" width="220" >
                        <template slot-scope="scope">
                        <el-button
                            size="small"
                            type="text"
                            @click="handleEdit(scope.row,0)"
                        >查看权限</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="220" >
                        <template slot-scope="scope">
                        <el-button  
                            size="small"
                            type="text"
                            @click="handleEdit(scope.row,1)"
                        >编辑</el-button>
                        <el-button 
                            size="small"
                            type="text"
                            @click="handleDelete(scope.row)"
                        >删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="page-part" style="padding:20px 20px 50px;">
                    <el-pagination  v-if="pageshow"
                        background
                        @size-change='handleSizeChange'
                        @current-change='handleCurrentChange'
                        :current-page="queryParams.page"
                        :page-sizes="[10,20,30,40]"
                        :page-size="queryParams.limit"
                        layout="total, prev, pager, next, jumper"
                        :total="total" style=" float:right;">
                    </el-pagination>
                </div>
            </div>
        </el-card>

        <el-dialog title="身份权限信息" :visible.sync="open" top="5vh" width="1000px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <el-form ref="form" :model="form" :rules="rules" label-width="110px">
                    <el-form-item label="身份名称:" prop="yhsf">
                        <el-input v-model="form.yhsf" clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-form>
                <el-table v-loading="loading" :data="quanxianList">
                    <el-table-column type="selection" width="55" align="center" />
                    <el-table-column  align="center" :show-overflow-tooltip="true"  label="序号" width="70">
                        <template slot-scope="scope">
                            <span>{{(scope.$index+1) + ( queryParams.limit * (queryParams.page-1))}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="模块名称" align="center" prop="item_qz" >
                        <template slot-scope="scope">
                            <el-input
                        v-model="scope.row.item_qz"
                        placeholder=""
                        clearable
                        size="small"
                        />
                        </template>
                    </el-table-column>
                    <el-table-column label="菜单名称" align="center" prop="item" >
                        <template slot-scope="scope">
                            <el-input
                        v-model="scope.row.item"
                        placeholder=""
                        clearable
                        size="small"
                        />
                        </template>
                    </el-table-column>
                    <el-table-column label="查看" align="center" width="80" >
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.ck" @change="getCheck(scope.row.ck)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="添加" align="center" width="80" >
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.xz" @change="getCheck(scope.row.xz)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="修改" align="center" width="80" >
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.xg" @change="getCheck(scope.row.xg)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="删除" align="center" width="80" >
                        <template slot-scope="scope">
                            <el-checkbox v-model="scope.row.sc" @change="getCheck(scope.row.sc)"></el-checkbox>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="60" >
                        <template slot-scope="scope">
                            <el-button 
                                size="small"
                                type="text"
                                @click="handleEditMenu(scope.row)"
                            >编辑</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="btns" style=" text-align:right;padding-top: 20px;" v-if="isbj==1">
                    <el-button type="warning" size="small" @click="selectAll">全选</el-button>
                    <el-button type="warning" size="small" @click="selectNo">全不选</el-button>
                    <el-button type="primary" size="small" @click="onSubmit()">确定</el-button>
                    <el-button size="small" @click="cancel">取消</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog title="菜单信息" :visible.sync="open2" top="5vh" width="600px" append-to-body :close-on-click-modal="false">
            <div class="nr">
                <el-form ref="formMenu" :model="formMenu" :rules="rules" label-width="110px">
                    <el-form-item label="菜单名称:" prop="label">
                        <el-input v-model="formMenu.label" size="small"  clearable placeholder="请输入" ></el-input>
                    </el-form-item>
                    <el-form-item label="路由:" prop="paths">
                        <el-input v-model="formMenu.paths" clearable placeholder="请输入" size="small" ></el-input>
                    </el-form-item>
                    <el-form-item label="url:" prop="url">
                        <el-input v-model="formMenu.url" clearable placeholder="请输入" size="small" ></el-input>
                    </el-form-item>
                    <el-form-item label="状态:" prop="show">
                        <el-radio-group v-model="formMenu.show" size="small">
                            <el-radio label="true">显示</el-radio>
                            <el-radio label="false">隐藏</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="排序:" prop="indexs">
                        <el-input v-model="formMenu.indexs" clearable placeholder="请输入" size="small" ></el-input>
                    </el-form-item>
                </el-form>
                <div class="btns" style=" text-align:right;padding-top: 20px;">
                    <el-button type="primary" size="small" @click="onSubmitMenu('formMenu')">确定</el-button>
                    <el-button size="small" @click="cancel2">取消</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'

export default {
    name: "Layout",
    data() {
        return {
            loading:false,
            queryParams:{
                yhsf:'',
                page:1,
                limit:10,
            },
            total:0,
            ajslList:[],
            open:false,
            pageshow:true,
            form:{},
            rules:{
                yhsf: [
                    { required: true, message: '身份名称不能为空', trigger: 'blur' }
                ],
            },
            isbj:0,
            quanxianList:[
                //{itemQz:"辅助办案管理",item: "一般程序处罚案件受理",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"辅助办案管理",item: "一般程序处罚案件列表",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"辅助办案管理",item: "决策分析",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"电子档案管理",item:"电子档案库",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"电子档案管理",item:"省案卷同步",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"案后评查",item: "事中评查解析",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"案后评查",item: "案卷智能解析",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"案后评查",item: "案卷电子评查",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"案后评查",item: "案卷上传列表",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"现场执法文书管理",item: "现场执法文书",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"相对人管理",item: "被监管对象管理",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"相对人管理",item:"无证库",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"系统设置",item: "操作员管理",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"系统设置",item: "工作部门",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"系统设置",item: "身份权限维护",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"系统设置",item: "系统信息维护",ck:false,xz:false,xg:false,sc:false},
                //{itemQz:"系统设置",item: "密码修改",ck:false,xz:false,xg:false,sc:false},
            ],
            qxId:'',
            sc: "",
            xg: "",
            xz: "",
            xianqu:'',
            cmid:'',
            menuId:'',
            open2:false,
            formMenu:{},
            baseUrl:''
        }
    },
    components: {
    },
    computed: {
    },
    created() {
    },
    mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xianqu = user.xianqu
        this.cmid = user.c_mid
        this.baseUrl = user.baseUrl
        console.log(user,this.cmid)
        let quxian = JSON.parse(sessionStorage.getItem("quxiandata"));
        console.log(quxian)
        if(quxian && quxian.length > 0){
            quxian.forEach(ele=> {
                if(ele.item == '身份权限维护'){
                    this.sc = ele.sc
                    this.xg = ele.xg
                    this.xz = ele.xz
                }
            })
        }
        this.getList()
    },
    methods: {
        async getList(){
            this.ajslList = []
            this.total = 0
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getFpqx`,
                data:{
                    yhsf:this.queryParams.yhsf,
                    limit:this.queryParams.limit,
                    page:this.queryParams.page
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                if(res.data.code == 0 && res.data.data){
                    this.ajslList = res.data.data.list
                    this.total = res.data.data.total || 0
                }else{
                    if(res.data.msg){
                        this.$message.error(res.data.msg)
                    }
                }
            }).catch(error => {
                this.$message.error(error);
            })
        },
        handleQuery(){
            this.pageshow = false;
            this.queryParams.page = 1
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleSizeChange(val){
            this.pagesize = val
            this.getList()
        },
        handleCurrentChange(val){
            this.pageshow = false;
            this.queryParams.page = val
            this.getList()
            this.$nextTick(() => {
                this.pageshow = true;
            });
        },
        handleAdd(){
            this.form = {}
            this.selectNo()
            this.isbj = 1
            this.getMenus()
            this.open = true
        },
        getCheck(){
            console.log(this.quanxianList)
        },
        async handleEdit(row,val){
            this.form = {}
            this.open = true
            this.form.yhsf = row.yhsf
            this.isbj = val
            this.qxId = row.ID
            console.log(this.qxId)
            this.getMenus(row.ID)
        },
        getMenus(id){
            axios({
                method: 'post',
                url: this.baseUrl+`/login/getIDSee`, 
                data:{
                    id: id,
                },
                headers: { 
                    "Content-Type": "application/json"
                },
            }).then(res => {
                console.log(res,852)
                if(res.data.code == 0){
                    this.quanxianList = res.data.data || []
                    this.quanxianList.forEach(item => {
                        if(item.ck == 1){
                            item.ck = true
                        }else{
                            item.ck = false
                        }
                        if(item.xz == 1){
                            item.xz = true
                        }else{
                            item.xz = false
                        }
                        if(item.xg == 1){
                            item.xg = true
                        }else{
                            item.xg = false
                        }
                        if(item.sc == 1){
                            item.sc = true
                        }else{
                            item.sc = false
                        }
                    })
                }
            })
        },
        handleDelete(row){
            this.$confirm("您确认要删除这条记录吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
            .then(async () => {
                axios({
                    method: 'post',
                    url: this.baseUrl+`/login/getIdFenPeiDel`,
                    data:{
                        id: row.ID,
                    },
                    headers: { 
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    if(res.data.code == 0){
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.getList()  
                    }else{
                        if(res.data.msg){
                            this.$message.error(res.data.msg)
                        }
                    }
                }).catch(error => {
                    this.$message.error(error);
                })	
                    
            })
            .catch(() => {
                this.$message({
                    type: "info",
                    message: "已取消删除"
                });
            });			
        },
        resetQuery(){
            this.queryParams = {
                yhsf:'',
                page:1,
                limit:10,
            }
            this.getList()
        },
        selectAll(){
            this.quanxianList.forEach(item => {
                //ck:false,xz:false,xg:false,sc:false
                item.ck = true
                item.xz = true
                item.xg = true
                item.sc = true
            })
            this.$forceUpdate()
        },
        selectNo(){
            this.quanxianList.forEach(item => {
                //ck:false,xz:false,xg:false,sc:false
                item.ck = false
                item.xz = false
                item.xg = false
                item.sc = false
            })
            this.$forceUpdate()
        },
        cancel(){
            this.form = {}
            this.open = false
        },
        cancel2(){
            this.formMenu = {}
            this.open2 = false
        },
        onSubmit(){
            console.log(this.qxId)
            console.log(this.quanxianList)
            // 这里需要保存数据，以及生成文书接口
            this.loading = true
            axios({
                method: 'post',
                url: this.baseUrl+`/login/saveYongQuanXian`,
                headers: { // 添加请求头
                    "Content-Type": "application/json" // 明确声明为 JSON 格式
                },
                data: {
                    id: this.qxId,
                    name:this.form.yhsf,
                    listVo:this.quanxianList,
                }
            }).then(res => {
                console.log(res)
                this.loading = false
                if(res.data){
                    if(res.data.length > 0 && res.data[0].errcode == 1){
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                    }else{
                        let tt = res.data[0].errMessage ? res.data[0].errMessage : '保存失败'
                        this.$message({
                            message: tt,
                            type: 'error'
                        });
                    }
                }else{
                    this.$message({
                        message: '保存失败，请重新填写',
                        type: 'error'
                    }); 
                }
            }).catch(res => {
                this.loading = false
            })
        },
        handleEditMenu(row){
            this.formMenu = row;
            this.formMenu.show = row.show ? row.show : 'true';
            console.log(row)
            this.open2 = true;
        },
        onSubmitMenu(formMenu){
            this.$refs[formMenu].validate((valid) => {
                if (valid) {
                    axios({
                        method: 'post',
                        url: this.baseUrl+`/pdfApi/updateMenu`,
                        headers: { // 添加请求头
                            "Content-Type": "application/json" // 明确声明为 JSON 格式
                        },
                        data: {
                            id:this.formMenu.id,
                            indexs:this.formMenu.indexs,
                            show:this.formMenu.show,
                            paths:this.formMenu.paths,
                            url:this.formMenu.url,
                            label:this.formMenu.label,
                        }
                    })
                    .then(response => {
                        console.log(response.data,845)
                        this.$message.success('保存成功！');
                        this.open2 = false;
                    })
                    .catch(error => {
                        this.$message.error('保存失败！');
                        console.error('There was an error!', error);
                        return '';
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>


<style scoped>
</style>